module.exports = __webpack_public_path__ + "static/media/attach-2.61fa7bd0.svg";